import React from "react"
import { Path, Rect } from "react-konva"


function Icon({
	type,
	color,
	bgColor,
	onClick,
	x=0,
	y=0,
	width=20,
	height=20,
	...props
}: IconProps) {
	const data = {
		[ICON_TYPE.COLLAPSE]: "M16.3333 17.5L11.0833 12.25C10.6667 12.5833 10.1875 12.8472 9.64583 13.0417C9.10417 13.2361 8.52778 13.3333 7.91667 13.3333C6.40278 13.3333 5.12153 12.809 4.07292 11.7604C3.02431 10.7118 2.5 9.43056 2.5 7.91667C2.5 6.40278 3.02431 5.12153 4.07292 4.07292C5.12153 3.02431 6.40278 2.5 7.91667 2.5C9.43056 2.5 10.7118 3.02431 11.7604 4.07292C12.809 5.12153 13.3333 6.40278 13.3333 7.91667C13.3333 8.52778 13.2361 9.10417 13.0417 9.64583C12.8472 10.1875 12.5833 10.6667 12.25 11.0833L17.5 16.3333L16.3333 17.5ZM7.91667 11.6667C8.95833 11.6667 9.84375 11.3021 10.5729 10.5729C11.3021 9.84375 11.6667 8.95833 11.6667 7.91667C11.6667 6.875 11.3021 5.98958 10.5729 5.26042C9.84375 4.53125 8.95833 4.16667 7.91667 4.16667C6.875 4.16667 5.98958 4.53125 5.26042 5.26042C4.53125 5.98958 4.16667 6.875 4.16667 7.91667C4.16667 8.95833 4.53125 9.84375 5.26042 10.5729C5.98958 11.3021 6.875 11.6667 7.91667 11.6667ZM5.83333 8.75V7.08333H10V8.75H5.83333Z",
		[ICON_TYPE.EXPANDED]: "M16.3333 17.5L11.0833 12.25C10.6667 12.5833 10.1875 12.8472 9.64583 13.0417C9.10417 13.2361 8.52778 13.3333 7.91667 13.3333C6.40278 13.3333 5.12153 12.809 4.07292 11.7604C3.02431 10.7118 2.5 9.43056 2.5 7.91667C2.5 6.40278 3.02431 5.12153 4.07292 4.07292C5.12153 3.02431 6.40278 2.5 7.91667 2.5C9.43056 2.5 10.7118 3.02431 11.7604 4.07292C12.809 5.12153 13.3333 6.40278 13.3333 7.91667C13.3333 8.52778 13.2361 9.10417 13.0417 9.64583C12.8472 10.1875 12.5833 10.6667 12.25 11.0833L17.5 16.3333L16.3333 17.5ZM7.91667 11.6667C8.95833 11.6667 9.84375 11.3021 10.5729 10.5729C11.3021 9.84375 11.6667 8.95833 11.6667 7.91667C11.6667 6.875 11.3021 5.98958 10.5729 5.26042C9.84375 4.53125 8.95833 4.16667 7.91667 4.16667C6.875 4.16667 5.98958 4.53125 5.26042 5.26042C4.53125 5.98958 4.16667 6.875 4.16667 7.91667C4.16667 8.95833 4.53125 9.84375 5.26042 10.5729C5.98958 11.3021 6.875 11.6667 7.91667 11.6667ZM7.08333 10.4167V8.75H5.41667V7.08333H7.08333V5.41667H8.75V7.08333H10.4167V8.75H8.75V10.4167H7.08333Z",
		[ICON_TYPE.RIGHT]: "M6.91248 14.0708L10.7291 10.2458L6.91248 6.42085L8.08747 5.24585L13.0875 10.2458L8.08748 15.2458L6.91248 14.0708Z",
		[ICON_TYPE.DOWN]: "M6.175 7.15833L10 10.975L13.825 7.15833L15 8.33333L10 13.3333L5 8.33333L6.175 7.15833Z",
	}[type]

	return <>
		{!!bgColor && <Rect {...props} 
			x={x} y={y} width={width} height={height} 
			onClick={onClick} 
			fill={bgColor} 
		/>}
		<Path {...props} data={data} 
			x={x} y={y} width={width} height={height} 
			fill={color} 
			listening={false}
		/>
	</>
}

export default Icon

type IconProps = {
	type: ICON_TYPE
} & { [key: string]: any }

export enum ICON_TYPE {
	COLLAPSE,
	EXPANDED,
	RIGHT,
	DOWN,
}
